import { API_BASE } from "../../../services/api";

const PLACEHOLDER = "/assets/smartpet-default.jpg";

export const getImageUrl = (url, fallback = PLACEHOLDER) => {
	if (!url) return fallback;
	if (
		url.startsWith("http://") ||
		url.startsWith("https://") ||
		url.startsWith("/")
	)
		return url;
	const base = API_BASE.endsWith("/") ? API_BASE.slice(0, -1) : API_BASE;
	return `${base}/${url.replace(/^\/+/, "")}`;
};

export default getImageUrl;
